export default __webpack_public_path__ + "static/media/set4.e2b75c81.jpeg";